module.exports = __webpack_public_path__ + "img/pharmacy_bookpill.f90622fa.svg";